// removed by extract-text-webpack-plugin
module.exports = {"base":"PaginationRender_base--1AgBL","base__isLast":"PaginationRender_base__isLast--3UUV5","baseIsLast":"PaginationRender_base__isLast--3UUV5","base__selected":"PaginationRender_base__selected--1NYMu","baseSelected":"PaginationRender_base__selected--1NYMu","selectedImage":"PaginationRender_selectedImage--27EwD"};


//////////////////
// WEBPACK FOOTER
// ./components/Pagination/PaginationList/PaginationRender/PaginationRender.scss
// module id = 2362
// module chunks = 11